import { useNavigate, useParams } from "react-router-dom";
import MeaPage from "../../../components/MeaPage";
import slotsAPI from "../../../services/slots";
import SlotDetailComponent from "./components/SlotDetailComponent";
import MeaPageTitle from "../../../components/MeaPageTitle";
import { useRef, useState } from "react";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import UpdateSlotModal from "./components/UpdateSlotModal";
import { Toast } from "primereact/toast";
import { TabMenu } from "primereact/tabmenu";
import MeaLoadingContent from "../../../components/MeaLoadingContent";
import ScheduleListComponent from "../schedule/components/ScheduleListComponent";
import { PERMISSION_TRAINING_SLOTS } from "../../../permissions";
import { useAuthContext } from "../../../hooks/useAuthContext";

const SlotDetailPage = () => {

  const { hasPermission } = useAuthContext();
  //
  const params = useParams();
  const schoolId = params.schoolId
  const trainingId = params.trainingId;
  const accessToken = "";
  //
  const updateModalRef = useRef();
  const toast = useRef();
  const navigate = useNavigate();
  const slotId = params.slotId;
  //
  const slotQuery = slotsAPI.GetOne(schoolId, trainingId, accessToken, slotId);
  const slotObj = slotQuery?.data?.data;
  // states
  const [activeItem, setActiveItem] = useState(0);
  const listRef = useRef();
  // params
  const items = [{ label: "Programme de la semaine", icon: "pi pi-clock" }];

  //
  return (
    <>
      <MeaPage
        showBackButton={true}
        title={<MeaPageTitle prefix={"Créneau:"} title={slotObj?.name} />}
        actions={[
          {
            label: "Modifier",
            icon: "pi pi-file-edit",
            disable: !hasPermission(PERMISSION_TRAINING_SLOTS.UPDATE),
            command: () => {
              if (updateModalRef.current) {
                updateModalRef.current.show(() => {
                  slotQuery.refetch();
                });
              }
            },
          },
          {
            separator: true,
            disable: !hasPermission(PERMISSION_TRAINING_SLOTS.UPDATE),
          },
          {
            label: "Supprimer",
            icon: "pi pi-trash",
            disable: !hasPermission(PERMISSION_TRAINING_SLOTS.DELETE),
            command: () => {
              confirmDialog({
                message: "Voulez-vous vraiment supprimer ce créneau?",
                header: "Confirmation",
                icon: "pi pi-info-circle",
                defaultFocus: "reject",
                acceptClassName: "p-button-danger",
                acceptLabel: "Oui",
                rejectLabel: "Non",
                accept: () => {
                  slotsAPI
                    .DeleteOne(schoolId, trainingId, accessToken, slotId)
                    .then((data) => {
                      toast.current.show({
                        severity: "success",
                        summary: "Succès",
                        detail: slotObj?.name + " Supprimé!",
                        life: 3000,
                      });
                      navigate(
                        "/school/" + schoolId + "/admin/trainings/" + trainingId + "/slots"
                      );
                    })
                    .catch((error) => {
                      toast.current.show({
                        severity: "error",
                        summary: "Erreur",
                        detail: "Erreur de suppression!",
                      });
                    });
                },
              });
            },
          },
        ]}
      >
        <SlotDetailComponent slot={slotObj} />
        <UpdateSlotModal ref={updateModalRef} slot={slotObj} schoolId={schoolId} trainingId={trainingId} accessToken={accessToken} />
        <ConfirmDialog />
        <Toast ref={toast} />

        <div className="mt-5">
          <TabMenu
            model={items}
            activeIndex={activeItem}
            onTabChange={(e) => {
              setActiveItem(e.index);
            }}
          />
          {activeItem === 0 && (
            <MeaLoadingContent objectQuery={slotQuery}>
              <ScheduleListComponent
                ref={listRef}
                schoolId={schoolId}
                trainingId={trainingId}
                filter={{ slot_id: slotId }}
                showAddButton={false}
                showFilterButton={true}
                selectedFields={{
                  slot: false,
                }}
              />
            </MeaLoadingContent>
          )}
        </div>
      </MeaPage>
    </>
  );
};
export default SlotDetailPage;
